const methodsSectionLayoutState = ({ justify } = { justify: 'start' }) => ({
  labelVisibility: 'show', // "show" | "hide" | "auto"
  grid: {
    columns: 'max', // <integer> | "max"
    justify,
    button: {
      $singlePaymentButton: {
        threshold: {
          small: 0
        }
      },
      minWidth: 50,
      paddingRight: 10,
      paddingY: 0
    },
    effectiveColumns: null
  },
  navigation: {
    views: ['main', 'group'], // main, group
    currentView: 'main',
    history: []
  }
})

export const getLayoutState = () => {
  return {
    layout: 'default', // compact | grid
    otherPaymentMethodsLayout: methodsSectionLayoutState(),
    preferredPaymentMethodsLayout: methodsSectionLayoutState({
      justify: 'stretch'
    })
  }
}

const sectionMethodsNavigate = ({ commit, state, dispatch }, key, view) => {
  if (!state.smartForm[key].navigation.views.includes(view)) return

  if (state.activeForm !== 'default') dispatch('focusForm', 'default')

  commit('UPDATE', {
    smartForm: {
      [key]: {
        navigation: {
          currentView: view
        }
      }
    }
  })
}

export const layoutActions = ($locator, app) => {
  return {
    opmNavigate(ctx, view) {
      return sectionMethodsNavigate(ctx, 'otherPaymentMethodsLayout', view)
    },
    ppmNavigate(ctx, view) {
      return sectionMethodsNavigate(ctx, 'preferredPaymentMethodsLayout', view)
    }
  }
}

export const layoutGetters = {
  isSmartFormCompact: ({ smartForm }, { isSmartFormPopin }) =>
    smartForm.layout === 'compact' && !isSmartFormPopin,
  isGridMode: ({ smartForm }) => smartForm.layout === 'grid'
}
